export function getFormattedActiveValueForGrid(value: 'true' | boolean | unknown): string {
    let isActive = value == 'true' || value === true;
    return `SystemSetup.Configuration.Actions.executionAgentFields.activeFilterValues.${isActive ? 'yes' : 'no'}`;
}
